angular.module('IndicatorTree', ['ui.tree', 'ui.tree-filter', 'ui.bootstrap', 'rzModule']);

angular.module('IndicatorTree').filter('highlight', function ($sce) {
  'use strict';
  return function (text, phrase) {
    if (phrase) {
      text = text.replace(new RegExp('(' + phrase + ')', 'gi'),
        '<span class="highlighted">$1</span>');
    }
    return $sce.trustAsHtml(text);
  };
});

angular.module('IndicatorTree').config(function (uiTreeFilterSettingsProvider) {
  uiTreeFilterSettingsProvider.addresses = ['title'];
});
